import { createActions } from '@u';
import types from './types';
import {
  applyService,
  getCurrentNot,
  setCurrentNot
} from './api';

const {
  REQUEST_START,
  REQUEST_SUCCESS,
  REQUEST_ERROR,
  APPLY_SERVICE,
  GET_CURRENT_NOT,
  SET_CURRENT_NOT
} = types;

export default createActions(
  {
    [APPLY_SERVICE]: applyService,
    [GET_CURRENT_NOT]: getCurrentNot,
    [SET_CURRENT_NOT]: setCurrentNot,
  },
  REQUEST_START,
  REQUEST_SUCCESS,
  REQUEST_ERROR,
);
